<template>
    <div class="app-container">
      <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'100px'" :search-btn-span="colSpan" :get-action="queryApi" :serial="serial" :before-reset-search="beforeResetSearch" :tooltip-config="{ contentMethod: false, enterable: true }" :selection="selection" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.No')" prop="orderNo">
              <BjInputCode v-model="queryParams.orderNo" :placeholder="$t('InternalOrder.No')" comma @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <BjSelectChannelStore :span="colSpan" :query-params="queryParams" :query-props="['channel', 'storeIdList']" multiple />
          <template v-if="businessType == ORDER_BUSINESS_TYPES.COMMON">
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.Doc')" prop="expressNo">
                <BjInputCode v-model="queryParams.expressNo" :placeholder="$t('InternalOrder.Doc')" @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.SKU')" prop="skuCode">
              <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('InternalOrder.SKU')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan" v-if="!$store.getters.cusId">
            <el-form-item :label="$t('customerNameText')" prop="cusId">
              <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
            </el-form-item
          ></el-col>
        </template>
        <template v-slot:seniorForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.Merchant')" prop="orderRemarks">
              <BjSelectLov v-model="queryParams.orderRemarks" :placeholder="$t('InternalOrder.Merchant')" lov-code="BJ_AFTER_REFUND_GOODS_REASONS" item-useable="status" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.source')" prop="actionType">
              <BjSelectLov v-model="queryParams.actionType" :placeholder="$t('InternalOrder.source')" :option-list="ORDER_ACTION_TYPE_LIST" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.Label')" prop="tags">
              <BjSelectLov v-model="queryParams.tags" :placeholder="$t('InternalOrder.Label')" :option-list="BJ_TAGS" multiple />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.form.sapOrderNo')" prop="sapOrderNo">
              <BjInput v-model="queryParams.sapOrderNo" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('InternalOrder.form.sapOrderNo')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.occupied')" prop="preemptionStatus">
              <BjSelectLov v-model="queryParams.preemptionStatus" :placeholder="$t('InternalOrder.occupied')" :option-list="ORDER_INTERNAL_PREEMPT_STATUS_LIST" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.Sourcing')" prop="sourceStatus">
              <BjSelectLov v-model="queryParams.sourceStatus" :placeholder="$t('InternalOrder.Sourcing')" :option-list="ORDER_INTERNAL_SOURCE_STATUS_LIST" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.Pending')" prop="suspendStatus">
              <BjSelectLov v-model="queryParams.suspendStatus" :placeholder="$t('InternalOrder.Pending')" :option-list="ORDER_INTERNAL_HAND_UP_STATUS_LIST" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.order')">
              <BjDateTimerangePicker v-model="queryParamsTime_order" :placeholder="$t('InternalOrder.order')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.Internal')">
              <BjDateTimerangePicker v-model="queryParamsTime_create" :placeholder="$t('InternalOrder.Internal')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.Estimated')">
              <BjDateTimerangePicker v-model="queryParamsTime_estimatedDelivery" :placeholder="$t('InternalOrder.Estimated')" />
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:beforeSearchBtn>
          <el-col :span="24 - colSpan">
            <el-tabs :value="queryParamsTradeStatus" type="card" @tab-click="handleTabClick">
              <el-tab-pane key="all" :label="$t('InternalOrder.All')" name="all" />
              <el-tab-pane v-for="(item, index) in ORDER_INTERNAL_ORDER_STATUS_LIST" :key="index + 1" :label="$t(item.label)" :name="item.value" />
            </el-tabs>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" :disabled="btnOrderStatus==-1 || btnOrderStatus!=0" @click="openShow">{{ $t('InternalOrder.AddException') }}</el-button>
            <el-button type="primary" :disabled="btnOrderStatus==-1 || btnOrderStatus!=3" @click="_orderNormal">{{ $t('InternalOrder.ReleaseException') }}</el-button>
            <el-button type="primary" @click="onExport">{{ $t('exportText') }}</el-button>
            <el-button type="primary" @click="onExportLogistics">{{ $t('InternalOrder.LogisticsInformationExport') }}</el-button>
            <el-button v-permission:BusinessThirdOrderIndex_download type="primary" @click="handleCommand">{{ $t('InternalOrder.byorder') }}</el-button>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop === 'outerOrderNo'">
                  <span class="link" @click="$toBusinessThirdOrderView(scope.row.outerOrderNo, false, businessType)">{{ scope.row.webReference }}</span>
                  <BjCopyIcon :copy="scope.row.webReference" />
                </template>
                <template v-else-if="col.prop === 'innerOrderNo'">
                  <span class="link" @click="$toBusinessOrderInternalView(scope.row.innerOrderNo, false, businessType)">{{ scope.row[col.prop] }}</span>
                  <BjCopyIcon :copy="scope.row[col.prop]" />
                </template>

                <template v-else-if="col.prop === 'orderStatusStr'">
                  <el-tag :type="scope.row[col.prop] === 'Proccessing' ? 'success' : 'info'">{{ scope.row[col.prop] }}</el-tag>
                </template>

                <template v-else-if="col.prop === 'tagsList'">
                  <BjTagList :tag-code-array="scope.row[col.prop]" size="mini" circle />
                </template>

                <template v-else-if="col.prop === 'goodsQuatity'">
                  <span class="link" @click="onSkuDetail(scope.row)">{{ scope.row[col.prop] }}</span>
                </template>
                <template v-else-if="
                    col.prop === 'totalAmount' || col.prop === 'buyerPay' || col.prop === 'costPrice'
                  ">
                  {{ $number2money(scope.row[col.prop]) }}
                </template>
                <template v-else-if="col.prop === 'deliveryStatus'">
                  <el-tag :type="scope.row[col.prop] === '30512' ? 'success' : 'info'">{{
                    $t(ORDER_INTERNAL_DELIVER_STATUS_LIST.bjGet(scope.row[col.prop]))
                  }}</el-tag>
                </template>
                <template v-else-if="col.prop === 'receivingStatus'">
                  <el-tag :type="scope.row[col.prop] === '30522' ? 'success' : 'info'">{{
                    $t(ORDER_INTERNAL_RECEIVING_STATUS_LIST.bjGet(scope.row[col.prop]))
                  }}</el-tag>
                </template>
                <template v-else-if="col.prop === 'stockFlag'">
                  {{ $t(STATUS_YES_NUM.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'isGift'">
                  <el-tag :type="scope.row[col.prop] ? 'success' : 'info'">{{
                    $t(STATUS_HAVE_TRUE.bjGet(scope.row[col.prop]))
                  }}</el-tag>
                </template>
                <template v-else-if="col.prop === 'actionType'">
                  {{ $t(ORDER_ACTION_TYPE_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'businessType'">
                  {{ $t(ORDER_BUSINESS_TYPE_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'takingDeliveryWay'">
                  {{ ORDER_TAKING_DELIVERY_TYPE_LIST.bjGet(scope.row[col.prop]) }}
                </template>
                <template v-else-if="col.prop === 'creationDate'">
                  <span>{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
                </template>
                <!-- #ifndef OPEN-SOURCE -->
                <template v-else-if="col.prop === 'preemptionStatus'">
                  {{ $t(ORDER_INTERNAL_PREEMPT_STATUS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'syncPreempStatus'">
                  {{ $t(ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <!-- #endif -->
                <template v-else-if="col.prop === 'sourceStatus'">
                  {{ $t(ORDER_INTERNAL_SOURCE_STATUS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'suspendStatus'">
                  {{ $t(ORDER_INTERNAL_HAND_UP_STATUS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'syncDeliveryStatus'">
                  {{ $t(ORDER_INTERNAL_STOCK_BACK_STATUS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="Object.keys(ORDER_DECRYPT_NAME).includes(col.prop)">
                  <BjDecrypt :row="scope.row" :row-key="col.prop" :channel="scope.row.channel" :type="ORDER_DECRYPT_NAME[col.prop]" :order-sn="scope.row.outerOrderNo" :copy="col.prop === 'receiverPhoneMask'" />
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 弹窗 -->
      <el-dialog :title="goodsInfoTab.title" :visible.sync="goodsInfoTab.visible" width="80%">
        <GoodsInfoTab :order-id="goodsInfoTab.orderId" :business-type="businessType" />
      </el-dialog>

      <formDialog ref="failReason" @comfirm="getFailReason" />

      <!-- 手工下载授权渠道订单 -->
      <DataForm ref="DataForm" @reFresh="reFresh"></DataForm>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { orderApi } from '@/api';
  import GoodsInfoTab from './components/GoodsInfoTab';
  import DataForm from './components/DataForm.vue';
  import {
    ORDER_TRADE_TYPE_LIST,
    ORDER_BUSINESS_TYPE_LIST,
    ORDER_ACTION_TYPE_LIST,
    STATUS_YES_NUM,
    STATUS_HAVE_TRUE,
    ORDER_INTERNAL_ORDER_STATUS_LIST,
    ORDER_INTERNAL_PREEMPT_STATUS_LIST,
    ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST,
    ORDER_INTERNAL_SOURCE_STATUS_LIST,
    ORDER_INTERNAL_DELIVER_STATUS_LIST,
    ORDER_INTERNAL_RECEIVING_STATUS_LIST,
    ORDER_INTERNAL_STOCK_BACK_STATUS_LIST,
    ORDER_INTERNAL_HAND_UP_STATUS_LIST,
    ORDER_TAKING_DELIVERY_TYPE_LIST,
    ORDER_BUSINESS_TYPES,
    ORDER_DECRYPT_NAME,
    SAP_ORDER_STATUS_LIST,
    HJ_ORDER_STATUS_LIST,
  } from '@/utils/constants';
  import BjDecrypt from '@/components/BjDecrypt/index.vue';
  import formDialog from './components/formDialog.vue';
  import axios from '@/utils/axios';
  import { downloadBlob } from '@/utils';

  export default {
    name: 'BusinessOrderInternal',
    components: { GoodsInfoTab, BjDecrypt, formDialog, DataForm, },
    mixins: [pageMiXin],
    data() {
      return {
        businessType: 'common',
        firstColSpan: 6,
        selection: true,
        colSpan: 4,
        SAP_ORDER_STATUS_LIST,
        HJ_ORDER_STATUS_LIST,
        ORDER_TRADE_TYPE_LIST,
        ORDER_BUSINESS_TYPE_LIST,
        ORDER_ACTION_TYPE_LIST,
        STATUS_YES_NUM,
        STATUS_HAVE_TRUE,
        ORDER_INTERNAL_ORDER_STATUS_LIST,
        // #ifndef OPEN-SOURCE
        ORDER_INTERNAL_PREEMPT_STATUS_LIST,
        // #endif
        ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST,
        ORDER_INTERNAL_SOURCE_STATUS_LIST,
        ORDER_INTERNAL_DELIVER_STATUS_LIST,
        ORDER_INTERNAL_RECEIVING_STATUS_LIST,
        ORDER_INTERNAL_STOCK_BACK_STATUS_LIST,
        ORDER_INTERNAL_HAND_UP_STATUS_LIST,
        ORDER_TAKING_DELIVERY_TYPE_LIST,
        ORDER_BUSINESS_TYPES,
        ORDER_DECRYPT_NAME,
        queryApi: orderApi.getInternalPage,
        // 查询参数
        queryParamsTime_order: [],
        queryParamsTime_pay: [],
        queryParamsTime_create: [],
        queryParamsTime_estimatedDelivery: [],
        queryParamsTime_delivery: [],
        queryParamsTime_confirmReceipt: [],
        queryParams: {
          businessType: this.businessType, // (string, optional): 订单业务类型，如：手工销售订单、直营销售订单、菜鸟外仓销售订单、京东外仓销售订单、直营退货退款订单、平台O2O销售订单、平台预售定金单等 ,
          actionType: null, // (string, optional): 订单创建类型：普通转单、手工单、复制单、导入单 ,
          buyerNick: null, // (string, optional): 买家昵称 ,
          buyerPayMax: null, // (number, optional): 买家应付最大金额 ,
          buyerPayMin: null, // (number, optional): 买家应付最小金额 ,
          buyerRemarks: null, // (string, optional): 买家备注/留言 ,
          channel: null, // (string, optional): 渠道 ,
          costPriceMax: null, // (number, optional): 总成本最大金额 ,
          costPriceMin: null, // (number, optional): 总成本最小金额 ,
          creationEndDate: null, // (string, optional): 内部单创建结束时间 ,
          creationStartDate: null, // (string, optional): 内部单创建起始时间 ,
          deliveryEndTime: null, // (string, optional): 发货结束时间 ,
          deliveryStartTime: null, // (string, optional): 发货起始时间 ,
          deliveryStatus: null, // (string, optional): 聚合商品行的发（收）货状态 ,
          expressNo: null, //  (string, optional): 物流单号
          deliveryEmailAddress: null, //  (string, optional): 邮箱
          isBuyerRemarks: null, // (boolean, optional): 买家是否有备注 ,
          isGift: null, // (boolean, optional): 有无赠品 ,
          isServiceRemarks: null, // (boolean, optional): 商家是否有备注 ,
          isOrderRemarks: null, // (string, optional): 订单备注 ,
          mobile: null, // (string, optional): 收货人手机号码 ,
          orderStatus: null, // (string, optional): 订单tab页切换 ,
          orderEndTime: null, // (string, optional): 三方下单结束时间 ,
          orderNo: null, // (string, optional): 第三方/内部订单号 ,
          orderStartTime: null, // (string, optional): 三方下单起始时间 ,
          payEndTime: null, // (string, optional): 支付结束时间 ,
          payStartTime: null, // (string, optional): 支付起始时间 ,
          predictDeliveryEndTime: null, // (string, optional): 预计发货结束时间 ,
          predictDeliveryStartTime: null, // (string, optional): 预计发货起始时间 ,
          preemptionStatus: null, // (string, optional): 聚合商品行的预占状态 ,
          receivedEndTime: null, // (string, optional): 确认收货结束时间 ,
          receivedStartTime: null, // (string, optional): 确认收货起始时间 ,
          receiverName: null, // (string, optional): 收货人姓名 ,
          receiveStatus: null, // 收货状态
          serviceRemarks: null, // (string, optional): 客服备注 ,
          orderRemarks: null, // (string, optional): 订单备注 ,
          skuCode: null, // (string, optional): SKU编码 ,
          cusId: null, // (string, optional): SKU编码 ,
          sourceStatus: null, // (string, optional): 聚合商品行的寻源状态 ,
          spuName: null, // (string, optional): SPU编码或者名称 ,
          stockFlag: null, // (boolean, optional): 是否缺货 ,
          storeId: null, // (integer, optional): 店铺id ,
          storeIdList: [],
          suspendStatus: null, // (boolean, optional): 订单级-挂起状态：0-正常，1-挂起成功，2-挂起失败，3-解挂成功，4-解挂失败 ,
          syncDeliveryStatus: null, //  (string, optional): 发货回写状态 ,
          syncPreempStatus: null, // (string, optional): 预占回写状态 ,
          tags: null, // (Array[string], optional): 标签
          totalAmountMax: null, // (number, optional): 商品总金额最大金额 ,
          totalAmountMin: null, // (number, optional): 商品总金额最小金额 ,
          tradeType: null, // (string, optional): 订单交易类型：销售单、仅退款单、退货退款单、换货单
          refundStatus: null, // 退款状态 ,
          o2oSearchDTO: {
            salesEmployeeRealName: null,
            takingDeliveryStore: [],
            takingDeliveryWay: null,
          },
        },
        goodsInfoTab: {
          title: this.$t('InternalOrder.Product'),
          visible: false,
          orderId: null,
        },
        queryParamsTradeStatus: null,
        btnOrderId: null,
      };
    },
    computed: {
      labelList() {
        const ARR = [
          { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190' },
          { label: this.$t('InternalOrder.form.Internal'), prop: 'innerOrderNo', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.sapOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false, width: '175' },
          { label: this.$t('InternalOrder.form.orderStatusStr'), prop: 'orderStatusStr', isCheck: true, disabled: false, width: '175' },
          // { label: this.$t('InternalOrder.form.sapOrderStatus'), prop: 'sapOrderStatus', isCheck: true, disabled: false, width: '150'},
          // { label: this.$t('InternalOrder.form.hjOrderStatus'), prop: 'hjOrderStatus', isCheck: true, disabled: false, width: '150'},
          { label: this.$t('InternalOrder.form.Label'), prop: 'tagsList', isCheck: true, disabled: false, width: '80' },
          { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false, width: '124'},
          { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '110'},
          { label: this.$t('InternalOrder.form.employee'), prop: 'salesEmployeeRealName', isCheck: true, disabled: false, width: '120'},
          { label: this.$t('InternalOrder.form.store'), prop: 'takingDeliveryStoreName', isCheck: true, disabled: false, width: '125'},
          { label: this.$t('InternalOrder.form.Source'), prop: 'actionType', isCheck: true, disabled: false, width: '125'},
          { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuatity', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.AbnormalCause'), prop: 'exception_reason', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.nickname'), prop: 'buyerNick', isCheck: true, disabled: false, width: '135'},
          { label: this.$t('InternalOrder.form.comments'), prop: 'buyerRemarks', isCheck: true, disabled: false, width: '135'},
          { label: this.$t('InternalOrder.form.Merchant'), prop: 'orderRemarks', isCheck: true, disabled: false, width: '180'},
          { label: this.$t('InternalReturnRefund.form.service'), prop: 'serviceRemarks', isCheck: true, disabled: false, width: '180'},
          { label: this.$t('InternalOrder.form.Method'), prop: 'takingDeliveryWay', isCheck: true, disabled: false, width: '180'},
          { label: this.$t('InternalOrder.form.sapPushTime'), prop: 'sapPushTime', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.sapPushTime'), prop: 'sapPullTime', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.hjPushTime'), prop: 'hjPushTime', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.hjLockTime'), prop: 'hjLockTime', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.hjShipmentTime'), prop: 'hjShipmentTime', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.document'), prop: 'trackingNumber', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.Total'), prop: 'totalAmount', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.cost'), prop: 'costPrice', isCheck: true, disabled: false, width: '170' },
          { label: this.$t('InternalOrder.form.placement'), prop: 'orderTime', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.creation'), prop: 'creationDate', isCheck: true, disabled: false, width: '165'},
          { label: this.$t('InternalOrder.form.delivery'), prop: 'predictDeliveryTime', isCheck: true, disabled: false, width: '180'},
          { label: this.$t('InternalOrder.form.Pre'), prop: 'preemptionStatus', isCheck: true, disabled: false, width: '180'},
          { label: this.$t('InternalOrder.form.Sourcing'), prop: 'sourceStatus', isCheck: true, disabled: false, width: '180' },
          { label: this.$t('InternalOrder.form.Pending'), prop: 'suspendStatus', isCheck: true, disabled: false, width: '180' },
        ];
        const NOT_IN_O2O_STR = 'salesEmployeeRealName,takingDeliveryStoreName,takingDeliveryWay';
        NOT_IN_O2O_STR.split(',').forEach(key => {
          const INDEX = ARR.findIndex(col => col.prop == key);
          if (INDEX > -1) {
            ARR.splice(INDEX, 1);
          }
        });
        return ARR;
      },
      SCHL_CHANNEL_TYPE() {
        return this.$store.state.values.SCHL_CHANNEL_TYPE || [];
      },
      BJ_TAGS() {
        return this.$store.state.values.BJ_TAGS || [];
      },
      addPermissionName() {
        return this.businessType == ORDER_BUSINESS_TYPES.COMMON
          ? 'BusinessOrderInternalAdd'
          : 'BusinessO2oInternalAdd';
      },
      btnOrderStatus() {
        if (this.selectedRows.length == 1) {
          this.btnOrderId = this.selectedRows[0].innerOrderNo;
          return this.selectedRows[0].orderStatus;
        } else {
          return -1;
        }
      }
    },
    watch: {
      queryParamsTime_order(v) {
        this.queryParams.orderStartTime = (v || [])[0];
        this.queryParams.orderEndTime = (v || [])[1];
      },
      queryParamsTime_create(v) {
        this.queryParams.creationStartDate = (v || [])[0];
        this.queryParams.creationEndDate = (v || [])[1];
      },
      queryParamsTime_pay(v) {
        this.queryParams.payStartTime = (v || [])[0];
        this.queryParams.payEndTime = (v || [])[1];
      },

      queryParamsTime_estimatedDelivery(v) {
        this.queryParams.predictDeliveryStartTime = (v || [])[0];
        this.queryParams.predictDeliveryEndTime = (v || [])[1];
      },
      queryParamsTime_delivery(v) {
        this.queryParams.deliveryStartTime = (v || [])[0];
        this.queryParams.deliveryEndTime = (v || [])[1];
      },
      queryParamsTime_confirmReceipt(v) {
        this.queryParams.receivedStartTime = (v || [])[0];
        this.queryParams.receivedEndTime = (v || [])[1];
      },

      'queryParams.orderStatus': {
        handler(v) {
          // 全部选项（name='all'）需要做特殊处理 对应 queryParams.orderStatus = null
          this.queryParamsTradeStatus = v || 'all';
          // TODO:这里执行一次搜索
          this.reFresh();
        },
        immediate: true,
      },
    },
    mounted() {
      this.$store.dispatch('values/getTags');
    },
    methods: {
      openShow() {
        if (this.selectedRows.length > 1) return this.$message.warning('只能选择一项');
        this.$refs.failReason.show();
      },
      _orderNormal() {
        orderApi.orderNormal({innerOrderNo: this.btnOrderId}).then(() => {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 2000);
        });
      },
      getFailReason(msg) {
        orderApi.orderException({
          msg,
          orderCode: this.btnOrderId
        }).then(() => {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 2000);
        });
      },
      handleTabClick(tab, event) {
        // 全部选项（name='all'）需要做特殊处理 对应 queryParams.orderStatus = null
        this.queryParams.orderStatus = tab.name == 'all' ? null : tab.name;
      },
      /** 重置按钮操作 */
      beforeResetSearch() {
        this.queryParamsTime_order = null;
        this.queryParamsTime_create = null;
        this.queryParamsTime_pay = null;

        this.queryParamsTime_estimatedDelivery = null;
        this.queryParamsTime_delivery = null;
        this.queryParamsTime_confirmReceipt = null;

        this.queryParams.totalAmountMin = null;
        this.queryParams.totalAmountMax = null;
        this.queryParams.buyerPayMin = null;
        this.queryParams.buyerPayMax = null;
        this.queryParams.costPriceMin = null;
        this.queryParams.costPriceMax = null;

        this.queryParams.isBuyerRemarks = null;
        this.queryParams.isOrderRemarks = null;
        this.queryParams.isServiceRemarks = null;

        this.queryParams.storeIdList = null;

        this.queryParams.tags = null;

        return new Promise(resolve => {
          resolve();
        });
      },
      /** 后端导出，接口导出 */
      async onExport() {
        const Ids = [];
        const res = await orderApi.pageExport(this.selectedRows.map(item => item.innerOrderNo));
        if (res.children.length > 0) {
            res.children.forEach(item => Ids.push(item.id));
            let outerOrderNoList = [];
            this.selectedRows.forEach(item => outerOrderNoList.push(item.innerOrderNo));
            outerOrderNoList = outerOrderNoList.join(',');
            axios({
                method: 'post',
                url: `/sord/v1/${this.$store.getters.tenantId}/order/order-page-import?rType=2&fillerType=single-sheet&exportType=DATA&ids=${Ids.join(',')}`,
                data: this.selectedRows.map(item => item.innerOrderNo),
                responseType: 'blob'
            }).then((res) => {
              downloadBlob(res.data, 'Order.xlsx');
              this.$refs.BjPage.onResetQuery();
            });
        }
      },

      // 物流信息导出 logisticsExport
      async onExportLogistics() {
        const Ids = [];
        const res = await orderApi.logisticsExport(this.selectedRows.map(item => item.innerOrderNo));
        // console.log(res, 'logisticsExport');
        if (res.children.length > 0) {
            res.children.forEach(item => Ids.push(item.id));
            let outerOrderNoList = [];
            this.selectedRows.forEach(item => outerOrderNoList.push(item.innerOrderNo));
            outerOrderNoList = outerOrderNoList.join(',');
            axios({
                method: 'post',
                url: `/sord/v1/${this.$store.getters.tenantId}/order/order-logis-import?rType=2&fillerType=single-sheet&exportType=DATA&ids=${Ids.join(',')}`,
                data: this.selectedRows.map(item => item.innerOrderNo),
                responseType: 'blob'
            }).then((res) => {
              downloadBlob(res.data, 'Logistics.xlsx');
              this.$refs.BjPage.onResetQuery();
            });
        }
      },

      // 手工下载授权渠道订单
      handleCommand() {
        this.$refs.DataForm.show();
      },

      /** 查看商品信息 */
      onSkuDetail(row) {
        this.goodsInfoTab.orderId = row.id;
        this.goodsInfoTab.visible = true;
      },
      /** 禁用 */
      onStatus(flag, row) {
        this.operationApi({
          flag: flag,
          id: row.id,
          objectVersionNumber: row.objectVersionNumber,
        });
      },

      /** 删除 */
      onDelete(row) {
        this.$confirm(this.$t('InternalOrder.form.Delete'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            this.batchDeleteApi({ id: row.id });
          })
          .catch(() => {});
      },
      operationApi(API_DATA) {
        orderApi.operationStockProcess(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        });
      },
      batchDeleteApi(API_DATA) {
        orderApi.deleteStockProcess(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        });
      },
    },
  };
  </script>

  <style scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
